import classNames from "classnames"
import { HTMLAttributes, ReactNode } from "react"

export const WorkspaceHomeSectionTitle = ({
    title,
    action,
    shouldShowBorder = true,
    ...rest
}: {
    title: string
    action?: ReactNode
    shouldShowBorder?: boolean
} & HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            {...rest}
            className={classNames(
                "w-full pb-4 flex items-center justify-between",
                { "border-b border-white-200 mb-6": shouldShowBorder },
                rest.className
            )}
        >
            <h2 className="text-gray-200 select-none">{title}</h2>
            {action}
        </div>
    )
}
